/**
 * /////////////////////////////////////////////////////////////////////////////
 *
 * https://keeptrack.space
 *
 * @Copyright (C) 2025 Kruczek Labs LLC
 *
 * KeepTrack is free software: you can redistribute it and/or modify it under the
 * terms of the GNU Affero General Public License as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * KeepTrack is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along with
 * KeepTrack. If not, see <http://www.gnu.org/licenses/>.
 *
 * /////////////////////////////////////////////////////////////////////////////
 */
import { SolarBody } from '@app/engine/core/interfaces';
import { settingsManager } from '../../../../settings/settings';
import { CelestialBody, PlanetColors } from './celestial-body';
export var MarsTextureQuality;
(function (MarsTextureQuality) {
    MarsTextureQuality["POTATO"] = "512";
    MarsTextureQuality["LOW"] = "1k";
    MarsTextureQuality["HIGH"] = "4k";
    MarsTextureQuality["ULTRA"] = "8k";
})(MarsTextureQuality || (MarsTextureQuality = {}));
export class Mars extends CelestialBody {
    RADIUS = 3389.5;
    NUM_HEIGHT_SEGS = 64;
    NUM_WIDTH_SEGS = 64;
    orbitalPeriod = 1.8808 * 365.25 * 24 * 3600;
    meanDistanceToSun = 227943824;
    eci;
    rotation = [0, 0, Math.PI * 7 / 10];
    color = PlanetColors.MARS;
    textureQuality = MarsTextureQuality.POTATO;
    getTexturePath() {
        return `${settingsManager.installDirectory}textures/mars${this.textureQuality}.jpg`;
    }
    useHighestQualityTexture() {
        this.textureQuality = MarsTextureQuality.ULTRA;
        this.loadTexture();
    }
    getName() {
        return SolarBody.Mars;
    }
    draw(sunPosition, tgtBuffer = null) {
        if (!this.isLoaded_ || settingsManager.isDisablePlanets) {
            return;
        }
        super.draw(sunPosition, tgtBuffer);
    }
}
